/* eslint-disable react-refresh/only-export-components */
import Image from "../base/Image"
import { signalWithStorage } from "@/utils/signal_utils"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import MarginTopBlock from "../base/MarginTopBlock"
import Svg from "../base/Svg"
import ButtonRegular, { ButtonRegularOutline } from "../composite/ButtonRegular/main"
import { Link, useNavigate } from "react-router-dom"
import { useCallback } from "react"
import { ModalSlideUpStaticMethods } from "../composite/ModalSlideUp/main"
import { PATHS } from "@/constants/path"
import BrandLogo from "../composite/BrandLogo"
import { IndexData } from "@/features_signal/indexData"
import { getAssetsUrlWithHttp } from "@/utils/common"
import { openExternalLink } from "@/utils/openExternalLink"
import AppSignals from "@/features_signal/app"

const paragraphs = [
    "Government Official or employee connected directly with the operation of the Government or any of its agencies.",
    "Member of the Armed Forces of the Philippines, including the Army, Navy, Air Force, or the Philippine National Police.",
    "Persons under 21 years of age.",
    "Persons included in the PAGCOR’s National Database of Restricted Persons (NDRP).",
    "Gaming Employment License (GEL) holder.",
]

export const signalIsTermsAndConditionsAgree = signalWithStorage(false, "isTermsAndConditionsAgree")

export const signalIsTermsAndConditionsProceeded = signalWithStorage(
    false,
    "isTermsAndConditionsProceeded",
)

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 32rem 16rem;
    background: linear-gradient(to bottom, #ffb4cd 0%, #fbfdff 10%, #fbfdff 100%);
    border-radius: 12rem 12rem 0 0;
    max-height: 90dvh;
    overflow-y: scroll;
`

const ParagraphContainer = styled.ul`
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    font-family: Gilroy;
    font-weight: 500;
    font-size: 16rem;
    line-height: 24rem;
    letter-spacing: 0%;
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 0;
    border-radius: 8rem;
    box-shadow: 0 0 0 1rem inset #00000025;
    padding: 12rem;
    margin: 0;
    gap: 8rem;
    user-select: none;
    pointer-events: none;
`

const Paragraph = styled.li`
    display: flex;
    align-items: baseline;
    gap: 8rem;
    font-family: Gilroy;
    font-weight: 400;
    letter-spacing: 0%;
`

export default function TermsAndConditions() {
    return (
        <Container>
            <BrandLogo
                css={css`
                    height: 32rem !important;
                    width: auto !important;
                    object-fit: contain;
                    user-select: none;
                    pointer-events: none;
                    margin-left: auto;
                    margin-right: auto;
                `}
            />
            <MarginTopBlock top={16} />
            <div
                css={css`
                    font-family: Gilroy;
                    font-weight: 500;
                    font-size: 16rem;
                    line-height: 24rem;
                    letter-spacing: 0%;
                    text-transform: capitalize;
                    user-select: none;
                    pointer-events: none;
                `}
            >
                The following personalities are not allowed to register and/or play in this online
                gaming website:
            </div>
            <MarginTopBlock top={12} />
            <ParagraphContainer>
                {paragraphs.map((paragraph) => (
                    <Paragraph key={paragraph}>
                        <Svg
                            css={css`
                                min-width: 8rem;
                                min-height: 8rem;
                                height: 8rem;
                                width: 8rem;
                            `}
                            src="pagcor/disc.svg"
                        />
                        <p
                            css={css`
                                padding: 0;
                                margin: 0;
                                font-size: 14rem;
                                line-height: 20rem;
                            `}
                        >
                            {paragraph}
                        </p>
                    </Paragraph>
                ))}
            </ParagraphContainer>
            <MarginTopBlock top={12} />
            <div
                css={css`
                    font-family: Gilroy;
                    font-weight: 400;
                    font-size: 14rem;
                    line-height: 20rem;
                    letter-spacing: 0%;
                    user-select: none;
                    pointer-events: none;
                    display: flex;
                    flex-direction: column;
                    gap: 4rem;
                `}
            >
                <div>
                    Funds or credits in the account of player who is found ineligible to play shall
                    mean forfeiture of said funds/credits in favor of the Government.
                </div>
                <div>Playing in open and public places is prohibited.</div>
            </div>
            <MarginTopBlock top={20} />
            <AgreeLine />
            <MarginTopBlock top={24} />
            <ButtonRegular
                css={css`
                    min-height: 40rem;
                `}
                disabled={!signalIsTermsAndConditionsAgree.value}
                onClick={() => {
                    signalIsTermsAndConditionsProceeded.value = true
                    ModalSlideUpStaticMethods.close("pagcor")
                }}
            >
                Proceed
            </ButtonRegular>
            <MarginTopBlock top={16} />
            {AppSignals.isMayaminiUser() ? (
                ""
            ) : (
                <ButtonRegularOutline
                    css={css`
                        min-height: 40rem;
                    `}
                    onClick={() => {
                        location.href = "https://www.facebook.com/filbet6"
                    }}
                >
                    Exit
                </ButtonRegularOutline>
            )}
            <MarginTopBlock top={16} />
            <div
                css={css`
                    display: flex;
                    align-items: stretch;
                    gap: 24rem;
                    user-select: none;
                    // justify-content: space-evenly;
                    justify-content: center;
                    > img {
                        height: 24rem;
                        width: auto;
                        object-fit: contain;
                    }
                `}
            >
                {IndexData.dataBottom.value.length > 0 ? (
                    <>
                        <Image
                            css={css``}
                            src={
                                getAssetsUrlWithHttp(IndexData.dataBottom.value[0]?.url) ||
                                "pagcor/pagcor_logo.webp"
                            }
                            onClick={() => {
                                openExternalLink(IndexData.dataBottom.value[0]?.link_h5 || "")
                            }}
                        />
                        {IndexData.dataBottom.value[1]?.url ? (
                            <>
                                <div
                                    css={css`
                                        background: linear-gradient(
                                            to bottom,
                                            #ffffff 0%,
                                            #1c1f2340 50%,
                                            #ffffff 100%
                                        );
                                        min-width: 1rem;
                                    `}
                                />
                                <Image
                                    css={css``}
                                    src={
                                        getAssetsUrlWithHttp(IndexData.dataBottom.value[1]?.url) ||
                                        "pagcor/pagcor_logo.webp"
                                    }
                                    onClick={() => {
                                        openExternalLink(
                                            IndexData.dataBottom.value[1]?.link_h5 || "",
                                        )
                                    }}
                                />
                            </>
                        ) : null}
                    </>
                ) : (
                    <>
                        <Image
                            css={css``}
                            src="pagcor/pagcor_logo.webp"
                        />
                        <div
                            css={css`
                                background: linear-gradient(
                                    to bottom,
                                    #ffffff 0%,
                                    #1c1f2340 50%,
                                    #ffffff 100%
                                );
                                min-width: 1rem;
                            `}
                        />
                        <Image
                            css={css``}
                            src="pagcor/21_required.webp"
                            onClick={() => {
                                openExternalLink("https://www.pagcor.ph/regulatory/")
                            }}
                        />
                    </>
                )}
            </div>
        </Container>
    )
}

const AgreeLineContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8rem;
    cursor: pointer;
`

const AgreeLineAnchor = styled.div`
    display: inline-flex;
    text-decoration: underline;
    color: #fb2d60;
    font-family: Gilroy;
    font-weight: 500;
    font-size: 13rem;
    line-height: 20rem;
    letter-spacing: 0%;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-thickness: 10%;
`

function AgreeLine() {
    const navigate = useNavigate()
    const onAnchorClick = useCallback(
        (name: string) => async (ev: React.MouseEvent<HTMLDivElement>) => {
            ev.preventDefault()
            ev.stopPropagation()
            navigate(`${PATHS.DOCS}/${name}`)
        },
        [navigate],
    )

    return (
        <AgreeLineContainer
            onClick={() => {
                signalIsTermsAndConditionsAgree.value = !signalIsTermsAndConditionsAgree.value
            }}
        >
            {signalIsTermsAndConditionsAgree.value ? (
                <Svg src="pagcor/checked.svg" />
            ) : (
                <Svg src="pagcor/un_chcked.svg" />
            )}
            <div
                css={css`
                    font-family: Gilroy;
                    font-weight: 400;
                    font-size: 13rem;
                    line-height: 20rem;
                    letter-spacing: 0%;
                `}
            >
                I agree to all{" "}
                <AgreeLineAnchor onClick={onAnchorClick("terms-of-use")}>
                    Terms of use
                </AgreeLineAnchor>
                ,{" "}
                <AgreeLineAnchor onClick={onAnchorClick("privacy-policy")}>
                    Privacy Policy
                </AgreeLineAnchor>{" "}
                and <AgreeLineAnchor onClick={onAnchorClick("faq")}>FAQ</AgreeLineAnchor>
            </div>
        </AgreeLineContainer>
    )
}
